// @flow weak

import {GET} from '../helpers/request';

export const GET_REQUEST = '@purchaseOrderList/GET_REQUEST';
export const GET_SUCCESS = '@purchaseOrderList/GET_SUCCESS';
export const GET_FAILURE = '@purchaseOrderList/GET_FAILURE';

export const FILTER_QUERY = '@purchaseOrderList/FILTER_QUERY';
export const FILTER_PROJECT_ID = '@purchaseOrderList/FILTER_PROJECT_ID';
export const FILTER_PURCHASED = '@purchaseOrderList/FILTER_PURCHASED';

export const SORT = '@purchaseOrderList/SORT';

const ordersRequest = () => ({
  type: GET_REQUEST,
});

const ordersSuccess = orders => ({
  type: GET_SUCCESS,
  orders,
});

const ordersFailure = error => ({
  type: GET_FAILURE,
  error,
});

export const fetchOrders = () => async dispatch => {
  dispatch(ordersRequest());
  try {
    const orders = await GET({endpoint: '/orders'}, dispatch);
    dispatch(ordersSuccess(orders));
  } catch (err) {
    dispatch(ordersFailure(err));
  }
};

export const filterByQuery = query => ({
  type: FILTER_QUERY,
  query,
});

export const filterByProjectId = projectId => ({
  type: FILTER_PROJECT_ID,
  projectId,
});

export const filterByPurchased = purchased => ({
  type: FILTER_PURCHASED,
  purchased,
});

export const sortItems = sorter => ({
  type: SORT,
  sorter,
});



// WEBPACK FOOTER //
// ./src/actions/purchaseOrderList.js